module.exports = __webpack_public_path__ + "img/emailIcon.62ca691a.svg";